import { z } from 'zod'
import { timestampSchema } from './common.ts'

export const PROCESS_TIMELINE_SOURCES = [
  'crm',
  'production',
  'warehouse',
  'logistics',
  'accounting',
  'documents',
] as const

export const processTimelineSourceSchema = z.enum(PROCESS_TIMELINE_SOURCES)
export type ProcessTimelineSource = z.infer<typeof processTimelineSourceSchema>

export const processTimelineDetailsSchema = z
  .object({
    orderNumber: z.string().optional(),
    productName: z.string().optional(),
    stageName: z.string().optional(),
    workCenterName: z.string().optional(),
    itemDescription: z.string().optional(),
    equipmentName: z.string().optional(),
    scrapQuantity: z.string().optional(),
    quantity: z.string().optional(),
    unit: z.string().optional(),
    reason: z.string().optional(),
    sourceBomVersion: z.string().optional(),
    materialName: z.string().optional(),
    warehouseName: z.string().optional(),
    locationName: z.string().optional(),
    note: z.string().optional(),
    shortage: z.string().optional(),
    ordered: z.string().optional(),
    toOrder: z.string().optional(),
    status: z.string().optional(),
    trackingNumber: z.string().optional(),
    recipientName: z.string().optional(),
    number: z.string().optional(),
    amount: z.string().optional(),
    currencyCode: z.string().optional(),
    fileName: z.string().optional(),
    version: z.string().optional(),
    comment: z.string().optional(),
  })
  .strict()

export const processTimelineItemSchema = z.object({
  source: processTimelineSourceSchema,
  kind: z.string().min(1),
  details: processTimelineDetailsSchema,
  actorName: z.string().nullable(),
  occurredAt: timestampSchema,
})

export type ProcessTimelineItem = z.infer<typeof processTimelineItemSchema>
